module.exports = __webpack_public_path__ + "static/img/Luyten-Jannis.be98494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Luyten-Jannis.jpg
// module id = P8Ip
// module chunks = 1